var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/moreicon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/More",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5,10 C5.88071187,10 7,11.1192881 7,12.5 C7,13.8807119 5.88071187,15 4.5,15 C3.11928813,15 2,13.8807119 2,12.5 C2,11.1192881 3.11928813,10 4.5,10 Z M12,10 C13.3807119,10 14.5,11.1192881 14.5,12.5 C14.5,13.8807119 13.3807119,15 12,15 C10.6192881,15 9.5,13.8807119 9.5,12.5 C9.5,11.1192881 10.6192881,10 12,10 Z M19.5,10 C20.8807119,10 22,11.1192881 22,12.5 C22,13.8807119 20.8807119,15 19.5,15 C18.1192881,15 17,13.8807119 17,12.5 C17,11.1192881 18.1192881,10 19.5,10 Z",
    id: "Rectangle-2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.5cb048fd3ac24bbd98552517a4c4523c.svg";
export { ForwardRef as ReactComponent };